// API base URL: dev uses Vite proxy, prod uses VPS
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL
  || (import.meta.env.DEV ? '/api' : 'https://app04.nextstepbu.com/api');
